<template>
    <div class="psychology backgroundImage">
        <template v-if="list.length > 0">
            <a-row type="flex" :gutter="[0, 20]" justify="space-between" style="width: 100%;padding: 0 42px;">
                <a-col :xs="24" :sm="11" :md="11" :lg="5" :xl="5" v-for="item, index in list" :key="index">
                    <div class="operateBox"
                        :style="{ backgroundColor: index == 0 ? '#BCD0FD' : index == 1 ? '#B2BCFA' : index == 2 ? '#FDBCDC' : '#7ED6FB' }"
                        @click="toPage(item)">
                        <span>{{ item.paperName }}</span> <i class="iconfont" style="font-size: 24px;">&#xe626;</i>
                    </div>
                </a-col>
            </a-row>
        </template>
        <template v-else >
            <a-empty description="暂无数据" />
        </template>
        
    </div>
</template>
<script>
import { getAction } from '@/api/manage'
export default {
    name: 'psychology',
    components: {},
    data() {
        return {
            list: []
        }
    },
    created() { this.init() },
    mounted() { document.title='问卷调查' },
    methods: {
        init() {
            getAction(`/teaching/teachingPaper/minePaperList?paperType=XLJK&pageSize=999`).then(res => {
                console.log(res, 'res')
                if (res.success) {
                    this.list = res.result
                }
            })
        },
        toPage(row) {
            this.$router.push({
                path: '/examination/Workbook', query: {
                    paperDeptId: row.paperDeptId,
                    paperId: row.paperId,
                    departId: row.departId,
                }
            });
        }
    }
}
</script>
<style lang='scss' scoped>
.psychology {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 50px);
    padding-top: 64px;
    background-image: url('../../assets/image/WJDC_FOOTER.png');
    .operateBox {
        width: 100%;
        height: 73px;
        display: flex;
        padding: 0 26px;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        color: #fff;
        border-radius: 14px;
        font-size: 20px;
        cursor: pointer;
    }
}
</style>

